(function () {
  function loadUpsell() {
    var c = document.getElementById('CartDrawer-Upsell');
    if (!c) return;
    if (c.querySelector('.cart-drawer__upsell-inner')) return;
    if (c.getAttribute('data-loading') === '1') return;
    var pid = c.getAttribute('data-product-id');
    if (!pid) return;
    c.setAttribute('data-loading', '1');
    fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'recommendations/products?section_id=cart-upsell&limit=10&intent=related&product_id=' + encodeURIComponent(pid))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var t = document.createElement('div');
        t.innerHTML = html;
        var inner = t.querySelector('.cart-drawer__upsell-inner');
        if (inner) c.appendChild(inner);
        c.removeAttribute('data-loading');
      })
      .catch(function () { c.removeAttribute('data-loading'); });
  }
  function ga(name, card) {
    try {
      var payload = {
        item_list_id: 'cart_drawer_upsell', item_list_name: 'Cart drawer upsell',
        items: [{ item_id: card.getAttribute('data-pid') || '', item_name: card.getAttribute('data-title') || '', price: parseFloat(card.getAttribute('data-price')) || undefined }]
      };
      if (typeof window.gtag === 'function') window.gtag('event', name, payload);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: name === 'add_to_cart' ? 'cart_upsell_add' : 'cart_upsell_click', ecommerce: payload });
    } catch (e) {}
  }
  function addToCart(variantId, btn) {
    var cart = document.querySelector('cart-drawer');
    var sections = (cart && cart.getSectionsToRender) ? cart.getSectionsToRender().map(function (s) { return s.id; }) : [];
    var body = { items: [{ id: variantId, quantity: 1 }] };
    if (btn && btn.getAttribute('data-preorder') === 'true') {
      var props = { _preorder: 'true' };
      var rd = btn.getAttribute('data-release-date');
      if (rd) props._release_date = rd;
      body.items[0].properties = props;
    }
    if (sections.length) { body.sections = sections; body.sections_url = window.location.pathname; }
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); return; }
        var card = btn.closest('.cart-upsell-card');
        if (card) ga('add_to_cart', card);
        if (cart && cart.renderContents) cart.renderContents(res);
      })
      .catch(function () { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); });
  }
  function init() {
    var drawer = document.querySelector('cart-drawer') || document.body;
    if (window.MutationObserver) {
      new MutationObserver(function () { loadUpsell(); }).observe(drawer, { attributes: true, childList: true, subtree: true });
    }
    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      var addBtn = e.target.closest('.cart-upsell-card__add[data-add-variant]');
      if (addBtn) { e.preventDefault(); e.stopPropagation(); addToCart(addBtn.getAttribute('data-add-variant'), addBtn); return; }
      var card = e.target.closest('.cart-upsell-card');
      if (card && !e.target.closest('.cart-upsell-card__add')) ga('select_item', card);
    }, true);
    setTimeout(loadUpsell, 400);
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
